export default __webpack_public_path__ + "static/media/h-thumbsUp.ebfb146a.gif";